import { ENV } from '../config/constant';
import { axios } from '../config/axios';
import { sliceParamAarry } from '../config/utils';
const { VUE_APP_API_HOST_ZLZ: HOST } = ENV;
/**
 * 分页查找gis-List
 */
export function searchGisList({
  RBianHaoAsc,
  createTimeAsc = false,
  frameContent = null,
  page,
  pageSize
} = {}) {
  return axios.get(`${HOST}/gis`, {
    params: {
      RBianHaoAsc,
      createTimeAsc,
      frameContent,
      page,
      pageSize
    }
  });
}
/**
 * 新建gis
 * {
  "polygon": [
    {
      "x": 0,
      "y": 0
    }
  ],
  "userUid": "string"
}
 */
export function createGis({ polygons, userUid, gisCoordinate }) {
  return axios.post(
    `${HOST}/gis`,
    { polygons, userUid, gisCoordinate },
    {
      headers: { 'Content-Type': 'application/json' }
    }
  );
}
/**
 * 通过gisId获得详情
 * @param {number} gisSearchAutoIncrementId
 */
export function getGisDetail(gisSearchAutoIncrementId) {
  return axios.get(`${HOST}/gis/${gisSearchAutoIncrementId}`);
}

/**
 * gis获取建筑表格
 */
export function getGisAreaRelicList(relicAutoIncrementIds) {
  return axios.get(`${HOST}/relic/table/gis?${relicAutoIncrementIds}`);
}

/**
 * 批量删除gislist
 */
export function deleteGisList(deleteList) {
  console.log(deleteList);
  const relicList = sliceParamAarry(deleteList);
  const promises = [];
  relicList.map(item => {
    const params = item
      .map(
        ({ gisSearchAutoIncrementId: id }) => `gisSearchAutoIncrementIds=${id}`
      )
      .join('&');
    console.log(params);
    promises.push(axios.delete(`${HOST}/gis?${params}`));
  });
  return Promise.allSettled(promises);
  // return axios.delete(`${HOST}/gis?${gisSearchAutoIncrementIds}`);
}

/**
 * 生成pdf压缩包
 */
export function generateZip({
  chaxunjieguo,
  gisSearchAutoIncrementId,
  guihuafanwei,
  photoUrl,
  relicAutoIncrementIds = []
} = {}) {
  gisSearchAutoIncrementId = Number(gisSearchAutoIncrementId);
  return axios.put(
    `${HOST}/gis/generatezip`,
    {
      chaxunjieguo,
      gisSearchAutoIncrementId,
      guihuafanwei,
      photoUrl,
      relicAutoIncrementIds
    },
    {
      headers: { 'Content-Type': 'application/json' }
    }
  );
}

/**
 * 更新gis的范围与查询结果
 */
export function updateGisMianJiResult({
  chaxunjieguo,
  gisSearchAutoIncrementId,
  guihuafanwei
}) {
  return axios.put(
    `${HOST}/gis/${gisSearchAutoIncrementId}?chaxunjieguo=${chaxunjieguo}&guihuafanwei=${guihuafanwei}`
  );
}

/**
 * 下载gis报告
 */
export function downloadFile(url) {
  return axios.get(url, {
    params: {},
    headers: {},
    // 重要
    responseType: 'blob'
  });
}
